<template>
    <div>
        <v-row>
            <v-col md="12">
                <v-stepper v-model="step" @reload="reloadstep($event)" non-linear>
                    <v-stepper-header>
                        <v-stepper-step :complete="step > 1" step="1" :color="`${buttonColor}`">
                            {{ $t("signatory.add.title_step_1") }}
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="step > 1.1" step="1.1" :color="`${buttonColor}`">
                            {{ $t("signatory.add.title_step_2") }}
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="step > 1.2" step="1.2" :color="`${buttonColor}`">
                            {{ $t("signatory.add.title_step_3") }}
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="step > 2" step="2" :color="`${buttonColor}`">
                            {{ $t("signatory.add.title_step_4") }}
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="step > 3" step="3" :color="`${buttonColor}`">
                            {{ $t("signatory.add.title_step_5") }}
                        </v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-items class="st_items">
                        <v-stepper-content step="1">
                            <v-container>
                                <v-row>
                                    <v-col md="12" class="text-center">
                                        <h2>{{ $t("signatory.add.subtitle_step_1") }}</h2>
                                    </v-col>
                                    <v-col class="text-center">
                                        <v-row>
                                            <v-col md="6" offset-md="3" class="text-center">
                                                <v-btn
                                                @click="yesCreated"
                                                :color="`${buttonColor}`"
                                                class="mt-6 mb-6 btn_bg"
                                                >{{ $t("signatory.add.button_yes_create_account")}}</v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-stepper-content>
                    </v-stepper-items>
                    <v-stepper-content step="1.1">
                        <v-row class="mb-2">
                            <v-col md="2" class="text-left" cols="12">
                                <v-btn
                                    @click="noCreated"
                                    :color="`${buttonColor}`"
                                    class="btn_back"
                                >{{ $t("riders.createRiders.previous")}}</v-btn>
                            </v-col>
                            <v-col md="8" class="text-center" cols="12">
                                <p class="mb-0">{{ $t("signatory.add.content_step_2") }}</p>
                            </v-col>
                            <v-col md="2" v-if="selected.length > 0" class="text-right">
                                <v-btn
                                    @click="yesCreated"
                                    :color="`${buttonColor}`"
                                    class="btn_back"
                                >{{ $t("riders.createRiders.next")}}</v-btn>
                            </v-col>
                        </v-row>
                        <v-form ref="formEmail" @submit.prevent="searchByEmail">
                            <v-row>
                                <v-col md="3" class="pt-0 pb-0" sm="6" cols="12">
                                    <label class="lbl_search">
                                    <v-icon>fa fa-search</v-icon>
                                    {{ $t("riders.createRiders.find_by_email") }}
                                    </label>
                                    <v-text-field
                                    v-model="email"
                                    :rules="rules.email" dense
                                    outlined>
                                    </v-text-field>
                                </v-col>
                                <v-col md="3" sm="6" cols="12" class="pb-8 pb-sm-2 pt-0 pt-sm-2">
                                    <v-btn class="mt-0 mt-sm-4" type="submit">{{ $t("riders.createRiders.search_by_email")}}</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                        <v-form ref="formLLId" @submit.prevent="searchByLLId">
                            <v-row>
                                <v-col md="3" class="pt-0 pb-0" sm="6" cols="12">
                                    <label class="lbl_search">
                                    <v-icon>fa fa-search</v-icon>
                                    {{ $t("riders.createRiders.find_by_ll_id") }}
                                    </label>
                                    <v-text-field 
                                    v-model="LLId"
                                    :rules="rules.LLId" dense
                                    outlined></v-text-field>
                                </v-col>
                                <v-col md="3" sm="6" cols="12" class="pb-8 pb-sm-2 pt-0 pt-sm-2">
                                    <v-btn class="mt-0 mt-sm-4" type="submit">{{ $t("riders.createRiders.search_by_ll_id")}}</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                        <v-row no-gutters>
                            <v-col cols="12">
                                <h4>{{ $t("signatory.add.search_results_table")}}</h4>
                            </v-col>
                            <v-col cols="12" class="mb-1">
                                <!-- Table ... -->
                                <v-data-table
                                    v-model="selected"
                                    :headers="headers"
                                    :items="items"
                                    :single-select="singleSelect"
                                    @click:row="selectRow"
                                    show-select
                                    item-key="id"
                                    class="elevation-2 ma-0 dt_rider" 
                                    dense
                                    :footer-props="{
                                        'items-per-page-text': $t('dataTable.rowsPerPageText'),
                                        'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                                    }"
                                    :no-data-text="$t('dataTable.noDataText')"
                                    :headerProps="{
                                        'sort-by-text': $t('dataTable.sortByText')
                                    }"
                                ></v-data-table>
                            </v-col>
                            <v-col v-if="participantSelected" class="text-left mt-1">
                                <!-- card selected -->
                                <h4>{{ $t("riders.createRiders.selected_rider")}}</h4>
                                <v-card max-width="344" outlined>
                                    <v-list-item v-for="(item, index) in selected" :key="index" two-line>
                                    <v-list-item-avatar tile size="80" color="grey" class="mb-2 mt-2">
                                            <v-img height="100%" width="100%" :src="item.image" v-on:error="ImgError"></v-img>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ item.firstName }} {{ item.lastName }}</v-list-item-title>
                                        <v-list-item-title>{{ $t("riders.createRiders.table_header_ll_id")}}: {{ item.id }}</v-list-item-title>
                                    </v-list-item-content>
                                    </v-list-item>
                                </v-card>
                            </v-col>
                        </v-row> 
                    </v-stepper-content>
                    <v-stepper-content step="1.2">
                        <v-container>
                            <v-row>
                                <v-col md="12">
                                    <p class="mb-0">{{ $t("authorization.add.content_step_3")}}</p>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="12" class="text-center">
                                    <h2>{{ $t("authorization.add.content_step_3")}}</h2>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="8" offset-md="2">
                                    <v-row>
                                    <v-col md="6" class="text-center">
                                        <v-btn
                                        @click="selectOrg"
                                        :color="`${buttonColor}`"
                                        class="mt-6 mb-6 btn_bg"
                                        target="_blank"
                                        >{{ $t("riders.createRiders.create_account_btn")}}</v-btn>
                                    </v-col>
                                    <v-col md="6" class="text-center">
                                        <v-btn
                                        @click="noCreated"
                                        :color="`${buttonColor}`"
                                        class="mt-6 mb-6 btn_bg"
                                        >{{ $t("riders.createRiders.create_already_btn")}}</v-btn>
                                    </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                        <v-container>  
                          <v-form ref="formAddRider" @submit.prevent="selectOrg">                          
                            <v-row>
                                <v-col md="6" class="text-left">
                                    <v-btn
                                    @click="noCreated"
                                    :color="`${buttonColor}`"
                                    class="btn_back"
                                    >{{ $t("riders.createRiders.back_button")}}</v-btn>
                                </v-col>
                                <v-col md="6" v-if="selected.length > 0" class="text-right">
                                    <v-btn
                                        @click="selectOrg"
                                        :color="`${buttonColor}`"
                                        class="btn_back"
                                    >{{ $t("riders.createRiders.next")}}</v-btn>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="12">
                                <p class="mb-0">{{ $t("signatory.add.content_step_3")}}</p>
                                </v-col>
                            </v-row>                
                            <div v-for="(item, index) in selected" :key="index">
                                <v-row>
                                    <v-col md="6" class="text-left">
                                        <v-card max-width="344" outlined>
                                        <v-list-item two-line>
                                            <v-list-item-avatar tile size="80" color="grey" class="mb-2 mt-2">
                                            <v-img height="100%" width="100%" :src="item.image" v-on:error="ImgError"></v-img>
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                            <v-list-item-title>{{ item.firstName }} {{ item.lastName }}</v-list-item-title>
                                            <v-list-item-title>{{ $t("riders.createRiders.table_header_ll_id")}}: {{ item.id }}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col md="6">
                                        <v-select 
                                          dense
                                          outlined 
                                          v-model="select1[item.id]"
                                          :rules="rules.select"
                                          :items="itemsRelationshipOptions"
                                          :label="$t('riders.whois')+item.firstName+' '+item.lastName+' ('+item.id+') '+$t('riders.whoisto')+' '+user.firstName+' '+user.lastName"
                                          :no-data-text="$t('common.no_data')"
                                        ></v-select>
                                    </v-col>
                                </v-row>
                            </div>
                          </v-form>
                        </v-container>
                    </v-stepper-content>
                    <v-stepper-content step="3">
                        <!-- Organization -->
                        <v-row>
                            <v-col md="6" class="text-left">
                                <v-btn
                                @click="step = 2"
                                :color="`${buttonColor}`"
                                class="btn_back"
                                >{{ $t("riders.createRiders.back_button")}}</v-btn>
                            </v-col>
                            <v-col md="6" class="text-right" v-if="organization.length > 0">
                                <v-btn
                                    @click="addRider"
                                    :color="`${buttonColor}`"
                                    class="btn_back"
                                >{{ $t("signatory.create")}}</v-btn>
                            </v-col>
                        </v-row>
                        <div v-for="(item, index) in selected" :key="index">
                            <v-row>
                                <v-col md="6" offset-md="3">
                                    <v-select 
                                      dense
                                      outlined 
                                      v-model="organization[item.id]"
                                      :rules="rules.selectOrg"
                                      :label="$t('signatory.select_org')"
                                      item-text="promoterName"
                                      item-value="documentId"
                                      :items="organizationItems"
                                      :no-data-text="$t('common.no_data')"
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </div>
                    </v-stepper-content>
                </v-stepper>
            </v-col>
        </v-row>
        <Snack :snack="snackbar" :snackMsg="msg_snackbar" :snackCol="color_snackbar"/> 
    </div>    
</template>
<script>
import RelationshipService from "../services/RelationshipService";
import AuthService from "../services/AuthService";
import WaiverService from "../services/WaiverService";
import Snack from '../components/notifications/Snack';
import { VRow, VCol, VStepperItems, VForm, VSelect, VStepper, VStepperContent, VContainer,
         VBtn, VDataTable, VTextField, VIcon, VStepperStep, VDivider, VStepperHeader, VListItemTitle,
         VListItemContent, VListItem, VImg, VListItemAvatar, VCard } from 'vuetify/lib';

export default {
  name: "CreateSignatory",
  components:{
    VRow, VCol, VStepperItems, VForm, VSelect, VStepper, VStepperContent, VContainer,
    VBtn, VDataTable, VTextField, VIcon, VStepperStep, VDivider, VStepperHeader, VListItemTitle,
    VListItemContent, VListItem, VImg, VListItemAvatar, VCard, Snack
  },
  data() {
    const createForm = Object.freeze({
      firstName: "",
      lastName: "",
      relationship: "",
      type: ""
    });
    return {
      snackbar: false,
      msg_snackbar: "",
      color_snackbar: "",
      step: 1,
      createForm,
      form: Object.assign({}, createForm),
      dynamicMenuItems: [],
      selected: [],
      items: [],
      singleSelect: false,
      select1: [],
      organization: [],
      organizationItems: [],
      itemsRelationship: [],
      buttonColor: "#000",
      email: null,
      LLId: null,
      participantSelected: false,
      imageUrl: null,
      failed_image: true,
      user: null,
      LIVELAPS_HOST: null,
      userRoleId: 0,
      userRolePartId: 0,
      userRolesItems: [],
      idUser: this.$route.params.id
    };
  },
  created(){
    this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
    this.LIVELAPS_HOST = this.$store.getters.env.get('VUE_APP_LIVELAPS_HOST');
    this.itemsRelationship_();
    this.getLinkedMembers();
  },
  mounted() {
    this.$emit("titlePage", "riders.addRiders");
    this.$emit("dynamicMenuItems", this.dynamicMenuItems);
  },
  updated(){
    this.itemsSelected();
  },
  computed: {
    createFormIsValid() {
      return (
        this.form.firstName &&
        this.form.lastName &&
        this.form.relationship &&
        this.form.type
      );
    },
    itemsRelationshipOptions(){
      return this.itemsRelationship.map((el) => {
        return {
          text: this.$t(`relationship.${el.toLowerCase()}`),
          value: el
        }
      }).sort((a, b) => a.text.localeCompare(b.text));
    },
    headers(){
      return [
        {
          text: this.$t("riders.createRiders.table_header_ll_id"),
          value: "id"
        },
        {
          text: this.$t("riders.createRiders.table_header_first_name"),
          value: "firstName"
        },
        {
          text: this.$t("riders.createRiders.table_header_last_name"),
          value: "lastName"
        }
      ]
    },
    rules() {
      return {
        select: [(v) => !!v || this.$t("riders.select_required")],
        selectOrg: [(v) => !!v || this.$t("signatory.organization_required")],
        email: [
          val =>
            (val || "").length > 0 ||
            this.$t("riders.email_required")
        ],
        LLId: [
          val => val > 0 || this.$t("riders.id_number_required")
        ],
        firstName: [
          val =>
            (val || "").length > 0 ||
            this.$t("riders.createRiders.firstname_required")
        ],
        lastName: [
          val =>
            (val || "").length > 0 ||
            this.$t("riders.createRiders.lastname_required")
        ],
        relationship: [
          val =>
            (val || "").length > 0 ||
            this.$t("riders.createRiders.relationship_required")
        ],
        type: [
          val =>
            (val || "").length > 0 ||
            this.$t("riders.createRiders.type_required")
        ]
      };
    },
  },
  methods: {
    getLinkedMembers(){
        let _data = [];
        WaiverService.participantWaivers(this.idUser).then(response => {
            if(response.data.success == 1){
            response.data.message.map(function(value) {
                _data.push(value);
            });
            }
        });
        this.organizationItems = _data;
    },
    async itemsRelationship_(){
      await RelationshipService.showRelationshipValues().then(response => {
        if(response.data.success == 1){
          this.itemsRelationship = response.data.message;
        }        
      });

      await RelationshipService.getUserRoles().then(response =>{
        if(response.data.success == 1){
          this.userRolesItems = response.data.message;
          this.userRolesItems.find(x => {
            if(x.userRoleCode === 'Signatory'){
              this.userRoleId = x.id;
            }
          });
        }
      });

      AuthService.getUserCurrent().then(response => {
        if (response.data.success == 1) {
          this.user = response.data.message;
        }
      });
    },
    async ImgError() {
      this.failed_image = false;
    },
    selectRow(item){
      let _item = this.selected.indexOf(item);
      if(_item > -1){
        this.selected.splice(_item, 1);        
      }else{
        this.selected.push(item);
      }
    },
    itemsSelected(){      
      if(this.selected.length > 0){
          this.participantSelected = true;
      } else {
          this.participantSelected = false;
      }
    },
    searchByEmail(){
      
      if(!this.$refs.formEmail.validate()) {
        return
      }
    
      RelationshipService.relationshipFinder('emailAddress',this.email).then(response => {
        if(response.data.success == 1){
          for(var i = 0; i < response.data.message.length; i++){
            response.data.message[i].image = (response.data.message[i].image != null && response.data.message[i].image.length > 0) ? this.$store.getters.env.get('VUE_APP_ROOT') +"/"+ response.data.message[i].image: require("@/assets/images/orgPlaceholder.jpg.png");
          }
          this.items = response.data.message;
        } else {
          this.items = [];
        }
      });
    },
    searchByLLId(){
      
      if(!this.$refs.formLLId.validate()) {
        return
      }
    
      RelationshipService.relationshipFinder('id',this.LLId).then(response => {
        if(response.data.success == 1){

          for(var i = 0; i < response.data.message.length; i++){
            response.data.message[i].image = (response.data.message[i].image != null && response.data.message[i].image.length > 0) ? this.$store.getters.env.get('VUE_APP_ROOT') +"/"+ response.data.message[i].image: require("@/assets/images/orgPlaceholder.jpg.png");
          }
          this.items = response.data.message;
        } else {
          this.items = [];
        }
        

      });
    },
    yesCreated() {
      switch (this.step) {
        case 1:
          this.step = 1.1;
          break;
        case 1.1:
          this.step = 2;
          break;
      }
    },
    noCreated() {
      switch (this.step) {
        case 1.1:
          this.step = 1;
          this.cleanData();
          break;
        case 2:
          this.step = 1.1;
          break;
        case 1:
          this.step = 1.2;
          break;
        case 1.2:
          this.step = 1;
          break;
      }
    },
    cleanData(){
      this.selected = [];
      this.email = null;
      this.LLId = null;
      this.participantSelected = false;
      this.items = [];
    },
    cancel() {
      this.step = 1;
      this.cleanData();
    },
    selectOrg(){
        if(!this.$refs.formAddRider.validate()) {
          return
        }else
          this.step = 3;
    },
    async addRider() {
      let _error = false;
        for(var i = 0; i < this.selected.length; i++){
           await RelationshipService.relationshipCreator({"relId": this.selected[i].id, "relType": this.select1[this.selected[i].id],"userRolesId": this.userRoleId}).then(response => {
             if(response.data.success == 1){
               let data = {
                 'waiver': this.organization[this.selected[i].id], //docId
                 'parent': this.selected[i].id, //fkUsersIdSlave
                 'userId': this.idUser
               }
               WaiverService.addSignatory(data).then(respons => {
                 if(respons.data.success == 1 && respons.data.message == 'not_add_signatory'){
                   this.msg_snackbar = this.$t("signatory.add.not_add_signatory");
                   this.snackbar = true;
                   this.color_snackbar = "danger";
                   _error = true;
                 }
               });
             }
           });
        }
      if(!_error){
        this.$router.go(-1);
      }
      
    },
    createAccount() {
      //go /regsitration/participant
    }
  }
};
</script>
<style scoped>
.btn_bg {
  height: 50px !important;
  min-width: 250px !important;
  color: #fff !important;
}
.btn_back{
  height: 50px !important;
  color: #fff !important;
}
.lbl_search .v-icon {
  margin-bottom: 5px;
  font-size: 18px;
}
.dt_rider .v-data-footer{
  height: 38px;
}
.dt_rider .v-data-footer__select .v-select{
  margin:0px 0px 0px 34px;
}
.dt_rider .v-data-table-header{
  background: #ccc;
}
.st_items .v-stepper__content{
  padding-top: 12px;
}
</style>